import React, { useMemo, useCallback, useState } from 'react';

import StockDetail from "Components/StockDetail";
import DialogPortal from "Components/DialogPortal";


const Signal = ({ attach }) => {
  
  const [showDetail, setOpenDetail] = useState(false);

  const { stnm, stcd, stsg, stpv, stcv, nv, rf, cv } = attach;
  const cr = (Number(cv) / (Number(nv) - Number(cv)))*100;
  const crFixed = !isNaN(cr) ? cr.toFixed(2) : '-';

  /*
    stnm : 종목명
    stcd : 종목코드
    stsg : 신호가
    stpv : 목표가
    stcv : 손절가
    nv:현재가
    cv:등락가
    rf : 4, 5 일경우 cv가 마이너스 값임.
    ----
    위 값이 없을 수 있음.
  */

  const handleClick = useCallback(()=>{
    if (!stcd) {
      return;
    }
    setOpenDetail(true);
  },[stcd]);

  const updownClass = useMemo(() => {
    if (cv === 0 || !cv || !rf) {
      return '';
    }
    if ([4, 5].includes(rf)) {
      return 'down';
    }
    return 'up'
  }, [rf, cv]);

  
  const domData = useMemo(() => {
    return nv ? (
      <p className="data">
        {nv ? Number(nv).toLocaleString('ko-KR') : '-'} <span className={`status ${updownClass}`}>{`${cv ? Number(cv).toLocaleString('ko-KR') : '-'} (${crFixed}%)`}</span>
      </p>
    ) : null;
  }, [crFixed, cv, nv, updownClass]);


  const domPrice = useMemo(() => {
    return stsg ? (
      <div className="price">
        <p>
          <span>매수가</span>
          <strong>{stsg ? stsg : '-'}</strong>
        </p>
        <p>
          <span>목표가</span>
          <strong className="fc_red">{stpv ? stpv : '-'}</strong>
        </p>
        <p>
          <span>손절가</span>
          <strong className="fc_blue">{stcv ? stcv : '-'}</strong>
        </p>
      </div>
    ) : null;
  }, [stcv, stpv, stsg]);


  return (
    <div className="cont">
      <div className="signal stock">
        <p className="title" style={stcd ? { cursor: 'pointer' } : null} onClick={handleClick}>{stnm || '-'} {stcd ? `(${stcd})` : ''}</p>
        {domData}
        {domPrice}
      </div>
      {
        showDetail ?
        <DialogPortal>
          <StockDetail stockDetail={{nm: stnm, cd: stcd}} callback={setOpenDetail.bind(null, false)} />
        </DialogPortal> : null
      }
    </div>
  )
}

export default React.memo(Signal);